import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/brand-search.png'
import _imports_1 from '../assets/images/collect-bg.png'
import _imports_2 from '../assets/images/collect-no.svg'


const _withScopeId = n => (_pushScopeId("data-v-676d7068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-wrapper" }
const _hoisted_2 = { class: "collect-content-wrapper" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "search-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "collect-bg"
}, null, -1))
const _hoisted_7 = { class: "right" }
const _hoisted_8 = ["infinite-scroll-disabled"]
const _hoisted_9 = {
  key: 0,
  class: "collect-no"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LinkardInfoItem = _resolveComponent("LinkardInfoItem")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_input, {
            placeholder: "搜索",
            modelValue: _ctx.searchKey,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKey) = $event)),
            onInput: _ctx.cardSearchInput
          }, null, 8, ["modelValue", "onInput"])
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives((_openBlock(), _createElementBlock("ul", {
          class: "card-list",
          "infinite-scroll-disabled": _ctx.noMoreCollectListData
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempCollectList, (linkInfo, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_LinkardInfoItem, { linkardInfo: linkInfo }, null, 8, ["linkardInfo"])
            ]))
          }), 128))
        ], 8, _hoisted_8)), [
          [_directive_infinite_scroll, _ctx.getCollectListRequest]
        ]),
        (_ctx.collectList != null && (_ctx.collectList.length == 0 || (_ctx.collectList.length != 0 && _ctx.tempCollectList.length == 0)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              (_ctx.collectList.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, "您暂未收藏联卡"))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, "暂无内容"))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}